(function () {
  var SECTION_SELECTOR = '.whyshift.whyshift-seen-world, .whyshift-seen-world';
  var SLIDE_SELECTOR = '.whyshift-seen-world__slide';
  var HOSTED_VIDEO_SELECTOR = '[data-whyshift-seen-world-video]';
  var FALLBACK_MP4S = [
    'https://cdn.shopify.com/videos/c/vp/d84850584ffa4f9ba88df21b2a0d74bd/d84850584ffa4f9ba88df21b2a0d74bd.HD-720p-1.6Mbps-86722578.mp4',
    'https://cdn.shopify.com/videos/c/vp/97873d450c4a4ba3a004f90d4cad2677/97873d450c4a4ba3a004f90d4cad2677.HD-720p-4.5Mbps-86726126.mp4',
    'https://cdn.shopify.com/videos/c/vp/e54a330b5b8540bc843d15a583268e82/e54a330b5b8540bc843d15a583268e82.HD-720p-3.0Mbps-86726128.mp4',
    'https://cdn.shopify.com/videos/c/vp/c9d7b694bb654fc0b3b2856bdc4da9ee/c9d7b694bb654fc0b3b2856bdc4da9ee.HD-720p-3.0Mbps-86726125.mp4'
  ];
  var FALLBACK_LABELS = ['STYLED', 'UNBOXED', 'ON BODY', 'IN ROTATION'];

  function isNearViewport(el, marginY, marginX) {
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vw = window.innerWidth || document.documentElement.clientWidth;
    return (
      rect.bottom >= -marginY &&
      rect.top <= vh + marginY &&
      rect.right >= -marginX &&
      rect.left <= vw + marginX
    );
  }

  function playHostedVideo(video) {
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    if (video.preload === 'none') video.preload = 'metadata';
    if (video.readyState < HTMLMediaElement.HAVE_METADATA) video.load();
    return video.play().catch(function () {});
  }

  function activateSlideMedia(slide) {
    slide.querySelectorAll(HOSTED_VIDEO_SELECTOR).forEach(function (video) {
      if (video.dataset.whyshiftSeenWorldAutoplay === 'false') return;
      playHostedVideo(video);
    });
  }

  function hydratePlaceholderSlides(section) {
    section.querySelectorAll(SLIDE_SELECTOR).forEach(function (slide, index) {
      var media = slide.querySelector('.whyshift-seen-world__media');
      if (!media) return;
      if (media.querySelector('video, img, iframe, .whyshift-seen-world__video-deferred')) return;

      var placeholder = media.querySelector('.whyshift-seen-world__placeholder');
      var src = FALLBACK_MP4S[index];
      if (!placeholder || !src) return;

      var video = document.createElement('video');
      video.className = 'whyshift-seen-world__video whyshift-seen-world__video--hosted';
      video.setAttribute('data-whyshift-seen-world-video', '');
      video.setAttribute('data-whyshift-seen-world-autoplay', 'true');
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.preload = 'metadata';

      var source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      video.appendChild(source);
      placeholder.replaceWith(video);

      var labelEl = slide.querySelector('.whyshift-seen-world__label');
      if (labelEl && FALLBACK_LABELS[index]) {
        labelEl.textContent = FALLBACK_LABELS[index];
      }
    });
  }

  function wakeSection(section) {
    hydratePlaceholderSlides(section);
    section.querySelectorAll(SLIDE_SELECTOR).forEach(function (slide) {
      if (isNearViewport(slide, 200, 64)) activateSlideMedia(slide);
    });
  }

  function initSection(section) {
    if (section.dataset.whyshiftSeenWorldRescueInit === 'true') return;
    section.dataset.whyshiftSeenWorldRescueInit = 'true';
    section.setAttribute('data-whyshift-seen-world', '');
    wakeSection(section);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) activateSlideMedia(entry.target);
          });
        },
        { root: null, rootMargin: '240px 0px', threshold: 0 }
      );
      section.querySelectorAll(SLIDE_SELECTOR).forEach(function (slide) {
        observer.observe(slide);
      });
    }

    var track = section.querySelector('[data-whyshift-carousel-track]');
    if (track) {
      track.addEventListener('scroll', function () {
        wakeSection(section);
      }, { passive: true });
    }

    // iOS often blocks autoplay until the first user gesture.
    var unlock = function () {
      wakeSection(section);
    };
    section.addEventListener('touchstart', unlock, { passive: true, once: true });
    document.addEventListener('touchstart', unlock, { passive: true, once: true });
  }

  function bootstrap() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  window.addEventListener('load', bootstrap);
  window.addEventListener('pageshow', bootstrap);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') bootstrap();
  });
})();
